export default __webpack_public_path__ + "static/media/set_password_icon.dd8572c3.svg";